import { render, staticRenderFns } from "./InicisResultComponent.vue?vue&type=template&id=c2f2d6f6&"
import script from "./InicisResultComponent.vue?vue&type=script&lang=js&"
export * from "./InicisResultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports